import React, { useState } from 'react'
import { useForm, SubmitHandler } from 'react-hook-form'
import classes from './Authentication.module.scss'
import Button from '../shared/ComponentLibrary/RButton'
import InputField from '../shared/ComponentLibrary/RInputField'
import TermsAndConditionsModal from './TermsAndConditionsModal'
import Icon from '../../Icon'

const SignUp = ({ SignUpHandler }: SignUpProps) => {
  const { register, handleSubmit, watch, formState: { errors } } = useForm()
  const [error, setError] = useState('')
  const [showTermsAndConditionsModal, setShowTermsAndConditionsModal] = useState<boolean>(false)
  const [acknowledgement, setAcknowledgment] = useState(false)
  const acknowledgmentCheckBox = watch('acknowledgement');
  const [showPassword, setShowPassword] = useState(false)
  const [showPasswordConfirmation, setShowPasswordConfirmation] = useState(false)


  const submitSignUp: SubmitHandler<IFormInputs> = (data) => {
    let signInData: ISignupUserData = {
      attributes: data,
      setError: setError
    }

    SignUpHandler(signInData)
  }

  const handleShowModal = () => {
    setShowTermsAndConditionsModal(true);
  };

  return (
    <div className={classes.authentication_container}>
      <TermsAndConditionsModal
        show={showTermsAndConditionsModal}
        setShow={setShowTermsAndConditionsModal}
      />
      <div className={classes.heading} >
        <div className={classes.title}>Get Started</div>
        <div className={classes.content}>Fill out the form below to register for your ReviewRight® account.</div>
      </div>
      <form className={classes.form} onSubmit={handleSubmit(submitSignUp)} >
        <div className={classes.side_by_side}>
          <div className={classes.field}>
            <InputField
              name='first name'
              label='First Name'
              register={{ ...register('firstName', { required: true }) }}
              error={errors.firstName}
              size='small'
              required
            />
          </div>

          <div className={classes.field}>
            <InputField
              name='last name'
              label='Last Name'
              register={{ ...register('lastName', { required: true }) }}
              error={errors.lastName}
              size='small'
              required
            />
          </div>
        </div>

        <div className={classes.field}>
          <InputField
            name='email'
            label='Email'
            register={{
              ...register('email', {
                required: true,
                pattern: {
                  value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i,
                  message: "invalid email address"
                },
                setValueAs: (value) => value.trim().toLowerCase()
              })
            }}
            error={errors.email}
            required
          />
        </div>
        <div className={`${classes.field} ${classes.password_field}`}>
          <InputField
            type={showPassword ? 'text' : 'password'}
            name='password'
            label='Password'
            register={{ ...register('password', { required: true }) }}
            error={errors.password}
            required
          />
          <button
            type='button'
            className={classes.password_toggle}
            onClick={() => setShowPassword((prev) => !prev)}
            aria-label={showPassword ? 'Hide password' : 'Show password'}
          >
            <Icon
              name={showPassword ? 'eye' : 'eyeOff'}
              size='18'
              color='#000000'
            />
          </button>
        </div>
        <div className={`${classes.field} ${classes.password_field}`}>
          <InputField
            type={showPasswordConfirmation ? 'text' : 'password'}
            name='passwordConfirmation'
            label='Confirm Password'
            register={{ ...register('passwordConfirmation', { required: true, minLength: 7, validate: (value) => { return value === watch('password') } }) }}
            error={errors.passwordConfirmation}
            required
          />
          <button
            type='button'
            className={classes.password_toggle}
            onClick={() => setShowPasswordConfirmation((prev) => !prev)}
            aria-label={showPasswordConfirmation ? 'Hide password' : 'Show password'}
          >
            <Icon
              name={showPasswordConfirmation ? 'eye' : 'eyeOff'}
              size='18'
              color='#000000'
            />
          </button>
        </div>
        <div className={classes.checkbox_field}>
          <input
            type="checkbox"
            defaultChecked={acknowledgement}
            data-dd-privacy="allow"
            {...register('acknowledgement')}
          />
          <span className={classes.TCcontainer}>I have read the <span onClick={handleShowModal} className={classes.TCstatement}>terms and conditions</span>.</span>
        </div>
        {error && <div className='text-danger'>{error}</div>}
        <div className={classes.submit_button}>
          <Button type='submit' size='large' innerText='Sign me up!' disabled={!acknowledgmentCheckBox} />
        </div>
      </form>
    </div>
  )
}

export default SignUp
